// src/plugins/axios.js
import axios from 'axios';
import token from './token';
import router from '@/router';
import logout from './logout';

export default {
    install: (app) => {
        const api = axios.create({
            baseURL: process.env.VUE_APP_API_BASE_URL,
            timeout: process.env.VUE_APP_API_TIMEOUT || 10000,
            headers: {
                'Content-Type': 'application/json',
            },
        });

        api.interceptors.request.use(
            (config) => {
                const auth = token.getToken(); // ambil token tersimpan

                if (auth?.token) {
                    config.headers.Authorization = `Bearer ${auth.token}`;
                }

                return config;
            },
            (error) => Promise.reject(error)
        );

        api.interceptors.response.use(
            (response) => {
                if (response.config.responseType === 'blob') {
                    return response; // ✅ sudah benar
                }
                return response.data;
            },
            async (error) => {
                // ⬇️ Tambahkan ini: parse blob error response jadi JSON
                if (
                    error.response?.config?.responseType === 'blob' &&
                    error.response?.data instanceof Blob
                ) {
                    try {
                        const text = await error.response.data.text();
                        const json = JSON.parse(text);
                        error.response.data = json;
                    } catch (_) {
                        // biarkan error aslinya
                    }
                }

                console.log(error);
                const excludedRoutes = [
                    'LoginPage',
                    'ForgotPasswordPage',
                    'RenewPassword',
                ];
                const currentRoute = router.currentRoute.value.name;
                if (!excludedRoutes.includes(currentRoute)) {
                    if (!token.isTokenValid()) {
                        token.removeToken();
                        // router.push('/login');
                        logout.routerLogout();
                    }
                }
                return Promise.reject(error);
            }
        );

        app.config.globalProperties.$axios = api;
        app.provide('axios', api);
    },
};
